export const getAdminUserListEndpoint = (params) =>
    `occ/v2/${localStorage.getItem('baseSiteId')}/users?${params}`;

export const getAssociatedAccountListEndpoint = (param) =>
    `occ/v2/${localStorage.getItem('baseSiteId')}/accounts/list?${param}`;

export const getAssociatedPhysicianListEndpoint = (param) =>
    `occ/v2/${localStorage.getItem('baseSiteId')}/physician/list?${param}`;

export const getAssociatedZGPhysicianListEndpoint = (param) =>
    `occ/v2/${localStorage.getItem('baseSiteId')}/physician/ZGphysicianList?${param}`;

export const getUserRoleEndpoint = () =>
    `occ/v2/${localStorage.getItem('baseSiteId')}/users/roles`;

export const getARDTlistEndpoint = (params) =>
    `occ/v2/${localStorage.getItem('baseSiteId')}/users/aardtList?level2=${
        params.payload.district
    }&level1=${params.payload.region}&resource=${
        params.payload.resource
    }&salesArea=${params.payload.area}&userId=${
        params.payload.userId
    }&userRole=${params.payload.userRole}&level3=${
        params.payload.subDistrict ? params.payload.subDistrict : ''
    }&level4=${
        params.payload.level4 ? params.payload.level4 : ''
    }
 
    `;

export const getNewAssignmentEndpoint = (params) =>
    `occ/v2/${localStorage.getItem('baseSiteId')}/users/assignment?district=${
        params.payload.district
    }&region=${params.payload.region}&salesArea=${
        params.payload.salesArea
    }&subDistrict=All_SubDistricts&territory=${
        params.payload.territory
    }&userId=${params.payload.userId}`;

export const updateUserEndpoint = () =>
    `occ/v2/${localStorage.getItem('baseSiteId')}/users`;

export const addProxyEndpoint = (queryParams) =>
    `occ/v2/${localStorage.getItem('baseSiteId')}/proxy/addproxy?endDate=${
        queryParams.endDate
    }&startDate=${queryParams.startDate}&uid=${queryParams.uid}&proxyForUid=${
        queryParams.proxyForUid
    }`;

export const updateProxyEndpoint = (queryParams) =>
    `occ/v2/${localStorage.getItem('baseSiteId')}/proxy/updateProxy?endDate=${
        queryParams.endDate
    }&startDate=${queryParams.startDate}&proxyId=${queryParams.proxyId}`;

export const getProxyListEndpoint = (params) =>
    `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/proxy/proxies?principalUser=${params}`;

export const revokeProxyEndpoint = (queryParams) =>
    `occ/v2/${localStorage.getItem('baseSiteId')}/proxy/${queryParams}`;

export const getAdminProxyUserListEndpoint = (param) =>
    `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/proxy/getProxyUsers?principalUser=${param.networkIdName}&isOutsideDistrict=${param.isOutsideDistrict}&page=${param.page}&pageSize=${param.pageSize ? param.pageSize : 100}&searchParam=${param.searchTerm ? param.searchTerm : ''}`;

export const getFilterDetailsEndpoint = (urlValue, param) =>
    `occ/v2/${localStorage.getItem('baseSiteId')}/${urlValue}?${param}`;
